import { Award, Globe, Package } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white border-y border-slate-200/80"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7 order-1">
            <Reveal>
              <span className="font-mono text-xs font-medium tracking-[0.2em] uppercase text-amber-600">
                About Us
              </span>
              <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900 leading-tight">
                Connecting Global Brands with the Egyptian Market for Over 30
                Years
              </h2>
              <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                With more than 30 years of experience in the Egyptian market,
                Top Service for Supplies &amp; Import has built a strong
                reputation as a trusted supplier, importer, and sourcing partner
                for major industrial and commercial organizations.
              </p>
            </Reveal>

            <Reveal delay={0.1}>
              <div
                data-testid="about-exxonmobil-callout"
                className="mt-6 rounded-2xl border border-slate-200 border-l-4 border-l-amber-500 bg-[#FBF9F5] p-6 sm:p-7"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-[#0B2545]">
                    <Award className="h-5 w-5 text-amber-400" />
                  </span>
                  <p className="font-heading text-lg font-semibold text-slate-900">
                    30+ Year Relationship with ExxonMobil Egypt
                  </p>
                </div>
                <p className="mt-4 text-slate-600 leading-relaxed">
                  For over three decades, we have maintained a long-standing
                  business relationship with ExxonMobil Egypt, supplying
                  products and specialized requirements sourced from trusted
                  manufacturers and suppliers around the world. We are a
                  registered contractor and vendor within ExxonMobil&apos;s
                  supplier system, supporting their procurement requirements with
                  reliable products, international sourcing, and professional
                  service.
                </p>
              </div>
            </Reveal>
          </div>

          <Reveal className="lg:col-span-5 order-2" delay={0.15}>
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-xl ring-1 ring-slate-900/5">
                <img
                  src={IMAGES.aboutPort}
                  alt="Industrial supplies and imports"
                  className="w-full h-[320px] sm:h-[420px] lg:h-[480px] object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-[#0B2545] rounded-xl px-6 py-5 shadow-xl hidden sm:block">
                <p className="font-heading text-3xl font-bold text-white">
                  30+ Years
                </p>
                <p className="text-xs text-amber-300 mt-1">
                  In the Egyptian Market
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          <Reveal>
            <div className="h-full rounded-2xl border border-slate-200/80 bg-[#FBF9F5] p-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#0B2545]">
                <Globe className="h-5 w-5 text-white" />
              </span>
              <h3 className="mt-5 font-heading text-xl sm:text-2xl font-semibold text-slate-900">
                Global Sourcing. Local Expertise.
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Our business is built around connecting the Egyptian market with
                reputable international manufacturers and established global
                brands. We source and import a wide range of industrial
                products, equipment, spare parts, valves, safety products, and
                other specialized supplies from manufacturers across different
                countries.
              </p>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Through our global sourcing, we provide our customers with access
                to quality products from recognized manufacturers, while handling
                the sourcing, importing, and supply process within Egypt.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="h-full rounded-2xl border border-slate-200/80 bg-[#FBF9F5] p-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#0B2545]">
                <Package className="h-5 w-5 text-white" />
              </span>
              <h3 className="mt-5 font-heading text-xl sm:text-2xl font-semibold text-slate-900">
                Our Own Product Portfolio
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">
                In addition to sourcing and importing products from
                international manufacturers, Top Service also imports selected
                products for distribution in the Egyptian market under our own
                commercial activities.
              </p>
              <p className="mt-3 text-slate-600 leading-relaxed">
                This enables us to serve customers with both international brands
                and carefully sourced products, depending on their technical,
                commercial, and operational requirements.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
